import { useState, useCallback } from 'react';
import { useFilterStore } from '@/store/useFilterOptionsStore';

interface UseFilterProps {
  initialCategories: {
    id: string;
    label: string;
    count: number;
    hasSearch?: boolean;
  }[];
  optionsData: Record<string, { id: string; value: string; label: string }[]>;
}

export const useFilterOptions = ({
  initialCategories,
  optionsData,
}: UseFilterProps) => {
  const { filterSelections, updateFilterSelections } = useFilterStore();

  const [selectedCategory, setSelectedCategory] = useState(
    initialCategories[0].id,
  );

  const handleOptionToggle = useCallback(
    (value: string) => {
      const currentSelections = filterSelections[selectedCategory] || [];
      const newSelections = currentSelections.includes(value)
        ? currentSelections.filter((v) => v !== value)
        : [...currentSelections, value];
      updateFilterSelections(selectedCategory, newSelections);
    },
    [selectedCategory, filterSelections, updateFilterSelections],
  );

  const getSelectedCount = useCallback(
    (categoryId: string) => filterSelections[categoryId]?.length || 0,
    [filterSelections],
  );

  return {
    selectedCategory,
    selectedOptions: filterSelections[selectedCategory] || [],
    handleOptionToggle,
    setSelectedCategory,
    getSelectedCount,
    currentOptions: optionsData[selectedCategory] || [],
  };
};
